'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (FAQAccordion, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.FAQAccordion = $('[data-faq-question]');
    };

    var FAQAccordionInit = function FAQAccordionInit(current) {
      if (current.parent().hasClass('active')) {
        current.parent().removeClass('active');
        current.next().slideUp(200);
      } else {
        $dom.FAQAccordion.parent().removeClass('active');
        current.parent().addClass('active').siblings().removeClass('active');
        $dom.FAQAccordion.next().slideUp(200);
        current.next().slideDown(200);
      }
    };

    var bindUIActions = function bindUIActions() {
      $dom.FAQAccordion.on('click', function () {
        FAQAccordionInit($(this));
      });
    };

    FAQAccordion.init = function () {
      cacheDom();
      bindUIActions();
    };
  })(window.FAQAccordion = window.FAQAccordion || {}, _jquery2.default, undefined);
};